import { render, staticRenderFns } from "./RequestNewPassword.vue?vue&type=template&id=55336dd9&scoped=true"
import script from "./RequestNewPassword.vue?vue&type=script&lang=js"
export * from "./RequestNewPassword.vue?vue&type=script&lang=js"
import style0 from "./RequestNewPassword.vue?vue&type=style&index=0&id=55336dd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55336dd9",
  null
  
)

export default component.exports